import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import imgGift from 'assets/images/eventWater/imgGift.png'
import imgWater from 'assets/images/eventWater/imgWater.png'
import imgBowl from 'assets/images/eventWater/imgBowl.png'
import imgPage from 'assets/images/eventWater/iconPage.png'
import imgRank from 'assets/images/eventWater/iconRank.png'
import iconTitleEvent from 'assets/images/eventWater/iconTitleEvent.png'
import iconTop1 from 'assets/images/eventWater/iconTop1.png'
import iconTop2 from 'assets/images/eventWater/iconTop2.png'
import iconTop3 from 'assets/images/eventWater/iconTop3.png'
import {
	getCheckEventWaterQuery,
	getDropEventWaterQuery,
	getRankEventWaterQuery,
} from 'dataLayer/game'
import { PATHS } from 'config/routes'
import { getUserQuery } from 'dataLayer/user'
import { Col, Row, Table } from 'react-bootstrap'
import Pagination from '@material-ui/lab/Pagination'
import CustomTable from './CustomTable'

const listImgRank = {
	1: iconTop1,
	2: iconTop2,
	3: iconTop3,
}

const EventWater = () => {
	const navigate = useNavigate()
	const [current, setCurrent] = useState(1)
	const [showMyRank, setShowMyRank] = useState(0)
	const [pageSize, setPagesize] = useState(10)
	const [dataTableRanks, setDataTableRanks] = useState([])
	const [dataTableMyRanks, setDataTableMyRanks] = useState([])
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())
	const { data: dataWater, refetch: refetchDrop } = useQuery(
		getDropEventWaterQuery(),
	)
	const {
		data: rankWater,
		isLoading: isLoadingRank,
		refetch: refetchRank,
	} = useQuery(getRankEventWaterQuery(current, showMyRank, pageSize))
	const {
		data: eventWater,
		isLoading: isLoadingEvent,
		refetch: refetchEvent,
	} = useQuery(getCheckEventWaterQuery())

	const [tabActive, setTabActive] = useState('EVENT')

	const { t } = useTranslation()
	// useEffect(() => {
	// 	document.title = t('title.terms')
	// }, [t])
	const columns = [
		{
			title: t('event.water.detail.package'),
			dataIndex: 'package',
			align: 'center',
		},
		{
			title: t('event.water.detail.number'),
			dataIndex: 'number',
			align: 'center',
		},
	]
	const columnsRank = [
		{
			title: t('event.water.rank.rank'),
			width: '10%',
			dataIndex: 'rank',
			align: 'center',
			render: text => {
				if (text == 1 || text == 2 || text == 3) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<img src={listImgRank[text]} />
						</div>
					)
				} else {
					return text
				}
			},
		},
		{
			title: t('event.water.rank.isdn'),
			width: '20%',
			dataIndex: 'msisdn',
			align: 'center',
		},
		{
			title: t('event.water.rank.name'),
			width: '30%',
			dataIndex: 'full_name',
			align: 'center',
			render: (text, row) => {
				return text || row.msisdn
			},
		},
		{
			title: t('event.water.rank.bucket'),
			width: '20%',
			dataIndex: 'bucket',
			align: 'center',
		},
		{
			title: t('event.water.rank.drop'),
			width: '20%',
			dataIndex: 'drop',
			align: 'center',
		},
	]
	const data = [
		{
			package: t('event.water.detail.winning'),
			number: '2 - 5',
		},
		{
			package: t('event.water.detail.register'),
			number: '5 - 10',
		},
		{
			package: t('event.water.detail.package_1'),
			number: '2 - 5',
		},
		{
			package: t('event.water.detail.package_2'),
			number: '5 - 10',
		},
		{
			package: t('event.water.detail.package_3'),
			number: '10 - 20',
		},
		{
			package: t('event.water.detail.package_4'),
			number: '20 - 30',
		},
		{
			package: t('event.water.detail.package_5'),
			number: '30 - 40',
		},
	]
	useEffect(() => {
		if (eventWater && !isLoadingEvent) {
			if (!eventWater.is_show || eventWater.is_finished) {
				navigate(PATHS.HOME_PAGE)
			}
		}
	}, [eventWater, isLoadingEvent])
	useEffect(() => {
		if (!isLoadingRank && rankWater?.ranks.data.length > 0) {
			let newListRank = rankWater.ranks.data.map((it, index) => {
				it.rank = index + 1 + (current - 1) * pageSize
				return it
			})
			setDataTableRanks(newListRank)
		}
		if (+rankWater?.ranks.total) {
			if (+rankWater?.ranks.total % 10) {
				rankWater.ranks.total = Math.floor(+rankWater?.ranks.total / 10) + 1
			} else {
				rankWater.ranks.total = Math.floor(+rankWater?.ranks.total / 10)
			}
		}
		if (user && rankWater?.myRank) {
			rankWater.myRank.rank = rankWater?.myRank.position
			setDataTableMyRanks([rankWater?.myRank])
		} else {
			setDataTableMyRanks([])
		}
	}, [isLoadingRank, pageSize, rankWater])
	useEffect(() => {
		refetchEvent()
		refetchRank()
		refetchDrop()
		if (user) {
			setShowMyRank(1)
		} else {
			setShowMyRank(0)
		}
	}, [user])

	const _onPressTab = tab => {
		if (tab != tabActive) {
			setTabActive(tab)
		}
	}
	const checkUserLogin = () => {
		if (!isLoadingUser) {
			if (!user) {
				return false
			} else {
				return true
			}
		}
		return false
	}

	const openModalLogin = () => {
		const btnLogin = document.getElementById(
			`button-login${window.innerWidth < 768 ? '-mb' : ''}`,
		)
		if (btnLogin !== undefined && btnLogin != null) btnLogin.click()
	}

	const _onPressBuyPackage = () => {
		navigate(PATHS.SHOP_PAGE)
	}

	return (
		<div className="container-water">
			<div className="container-water-wrapper">
				<Row justify="center" style={{ margin: 0 }}>
					<Col xs={24} style={{ padding: 0 }}>
						<div
							className={`container-water-content ${tabActive.toLowerCase()}`}
						>
							<div className="box-tab">
								<span
									onClick={() => _onPressTab('EVENT')}
									className={`box-tab-item unselected ${tabActive == 'EVENT' ? 'active' : ''
										}`}
								>
									{t('event.water.tab.name_event')}
								</span>
								<span
									onClick={() => _onPressTab('DETAIL')}
									className={`box-tab-item unselected ${tabActive == 'DETAIL' ? 'active' : ''
										}`}
								>
									{t('event.water.tab.detail')}
								</span>
								<span
									onClick={() => _onPressTab('RANK')}
									className={`box-tab-item unselected ${tabActive == 'RANK' ? 'active' : ''
										}`}
								>
									{t('event.water.tab.rank_table')}
								</span>
							</div>
							<div className="box-tab-content">
								{tabActive == 'EVENT' && (
									<div
										className={`box-tab-content-detail ${tabActive == 'EVENT' ? '' : 'hidden'
											}`}
									>
										<div className="wheel-wrapper">
											<div className="wheel-wrapper-your-bowl">
												<div className="title">
													{t('event.water.event_main.your_collection')}
												</div>
												<div className="box-img">
													<img src={imgBowl} alt="img bowl" />
													<span>{`x ${dataWater?.bucket || 0}`}</span>
												</div>
											</div>
											<img
												className="wheel-wrapper-icon-title"
												src={iconTitleEvent}
												alt="icon"
											/>
											<div className="wheel-wrapper-event">
												<div className="wheel-wrapper-event-img">
													<div className="wheel-wrapper-event-img-item">
														<img src={imgGift} alt="img gift" />
													</div>
													<div className="wheel-wrapper-event-img-item">
														<img src={imgWater} alt="img gift" />
														<span>{dataWater?.drop || 0}</span>
													</div>
												</div>
												<p className="wheel-wrapper-event-text">
													{t('event.water.event_main.text_d1')}
													<br />
													{t('event.water.event_main.text_d2')}
													<br />
													{t('event.water.event_main.text_d3')}
												</p>
												<div className="wheel-wrapper-event-button-bottom">
													<span
														onClick={() => {
															navigate(PATHS.HOME_PAGE)
														}}
														className="wheel-wrapper-button-bottom-btn-detail unselected"
													>
														{t('event.water.event_main.play_now')}
													</span>
													<span
														onClick={() => _onPressBuyPackage()}
														className="wheel-wrapper-button-bottom-btn-buy-package unselected"
													>
														{t('event.water.event_main.buy_more_package')}
													</span>
												</div>
											</div>
										</div>
									</div>
								)}
								{tabActive == 'DETAIL' && (
									<div
										className={`box-tab-content-detail ${tabActive == 'DETAIL' ? '' : 'hidden'
											}`}
									>
										<div className="wapper-detail">
											<img src={imgPage} alt="icon page" />
											<div className="wapper-detail-box">
												<div className="wapper-detail-box-content">
													<p level={3} style={{ textAlign: 'center' }}>
														{' '}
														<span>{t('event.water.detail.title')}</span>
													</p>
													<p>
														<span>{t('event.water.detail.text_d1_1')}</span>{' '}
														{t('event.water.detail.text_d1_2')}
													</p>
													<p>
														<span>{t('event.water.detail.text_d2_1')}</span>
														{t('event.water.detail.text_d2_2')}
														<ul>
															<li> {t('event.water.detail.text_d3')} </li>
															<li>{t('event.water.detail.text_d4')}</li>
															<li>{t('event.water.detail.text_d5')}</li>
														</ul>
													</p>
													<span>{t('event.water.detail.text_d6_1')}</span>
													<p>{t('event.water.detail.text_d6_2')}</p>

													<span>{t('event.water.detail.text_d7_1')}</span>
													<p>{t('event.water.detail.text_d7_2')}</p>
													<CustomTable
														columns={columns}
														dataSource={data}
														style={{ marginBottom: '1em' }}
														pagination={false}
														scroll={{ x: true }}
														bordered
													/>
												</div>
											</div>
										</div>
									</div>
								)}
								{tabActive == 'RANK' && (
									<div
										className={`box-tab-content-detail ${tabActive == 'RANK' ? '' : 'hidden'
											}`}
									>
										<div className="wapper-detail rank">
											<img src={imgPage} alt="icon page" />
											<img className="rank" src={imgRank} alt="icon Rank" />
											<div className="wapper-detail-box">
												<CustomTable
													columns={columnsRank}
													dataSource={dataTableRanks}
													pagination={false}
													scroll={{ x: true }}
													className="table-rank"
													rowClassName={(record, index) => {
														if (record.msisdn === user?.msisdn) {
															return 'row-current-user'
														}
													}}
													bordered
												/>
												{+rankWater?.ranks.total > 1 ? (
													<div className="wapper-detail-box-pagination">
														<Pagination
															count={rankWater?.ranks.total}
															shape="rounded"
															size="small"
															page={+rankWater?.ranks.current || 1}
															onChange={(event, page) => {
																setCurrent(page)
															}}
														/>
													</div>
												) : null}
												{dataTableRanks.length === 0 && !isLoadingRank ? (
													<div className="wapper-detail-box-nodata">
														<img
															className="img--no-data"
															src={noDataIcon}
															alt="No reward is found"
														/>
													</div>
												) : null}
												{user &&
													!isLoadingRank &&
													dataTableMyRanks.length > 0 && (
														<div className="wapper-detail-box-current-rank">
															<div className="wapper-detail-box-current-rank-title">
																{t('event.water.rank.my_rank')}
															</div>
															<CustomTable
																columns={columnsRank}
																dataSource={dataTableMyRanks}
																pagination={false}
																scroll={{ x: true }}
																isShowTitle={false}
																bordered
																className="table-rank-current"
															/>
														</div>
													)}
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default EventWater
